import React from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import styles from "./BusinessSolutions.module.scss";
import { Banner } from "../../components/Banner/Banner";
import { Image } from "../../components/Image/Image";
import { SVGIcon } from "../../components/SVGIcon/SVGIcon";
import { Button } from "../../components/Button/Button";
import businessImageM from "../../images/business-solutions-m.jpg";
import businessImageD from "../../images/business-solutions-d.jpg";
import enterpriseImageM from "../../images/business-enterprises-m.jpg";
import enterpriseImageD from "../../images/business-enterprises-d.jpg";

export const BusinessSolutions = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.businessSolutions.title}</title>
        <meta
          name="description"
          content="Cityside Fiber’s small business and enterprise solutions provide reliable, cost-effective connectivity that allows your company to thrive."
        />

        <meta property="og:title" content={`${ROUTES.businessSolutions.title}`} />
        <meta property="og:description" content="Cityside Fiber is the premier choice for high-speed internet and WiFi connectivity for small and medium businesses." />
        <meta property="og:url" content="https://www.citysidefiber.com/business-solutions" />
      </Helmet>

      <section className={styles.hero}>
        <div className={styles.designElement}></div>
        <div className={styles.designElement2}></div>

        <div className="grid-12">
          <div className={styles.container}>
            <h1 className="headline__h1 color--white">
              Light Your Business On Fiber
            </h1>

            <p className="subtitle color--white">
              Cityside Fiber’s small business and enterprise solutions provide
              reliable, cost-effective connectivity that allows your company to
              thrive.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.businesses}>
        <div className="grid-12">
          <div className={styles.container}>
            <div className={styles.content}>
              <div>
                <h2 className="headline__h1">
                  For Small and
                  <br />
                  Medium Businesses
                </h2>

                <p>
                  Cityside Fiber's managed Internet and WiFi solution for
                  businesses allows you to focus on growth, productivity, and
                  profitability. Our focus is on simplifying your IT needs and
                  enhancing data security while fueling your business with the
                  power of fiber.
                </p>
              </div>

              <ul className={styles.list}>
                <li>
                  <SVGIcon color="marina-blue" id="globe" /> Dedicated Business
                  Network
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="shield" /> PCI DSS Secured
                  Point of Sale Network
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="security" /> Network Security
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="restrictions" /> Content
                  Restrictions
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="customers" /> Customized
                  Customer Portal
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="cloud-backup" /> Cellular
                  Back-Up POS Connection
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="security-system" /> Security
                  System and Camera Connection
                </li>
                <li>
                  <SVGIcon color="marina-blue" id="customer-database" />{" "}
                  Remarketing to your Customer Database
                </li>
              </ul>

              <p>
                Through the MyCity WiFi app, you choose how to prioritize
                multiple secure connections with just a few clicks, getting you
                quickly back to running your business.
              </p>

              <Button
                size="lg"
                gradient="orange"
                href="mailto: sales@citysidefiber.com"
              >
                Inquire Today
              </Button>
            </div>

            <div className={styles.imageWrap}>
              <Image
                sources={[
                  {
                    src: businessImageM,
                    breakpoint: "default",
                  },
                  {
                    src: businessImageD,
                    breakpoint: "960px",
                  },
                ]}
                alt="woman in fron of bakery counter"
              />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.exterprises}>
        <div className="grid-12">
          <div className={styles.container}>
            <div className={styles.content}>
              <div>
                <h2 className="headline__h1">For Enterprises</h2>

                <p>
                  Cityside's fiber network is designed to provide medium and
                  large businesses with connectivity possibilities closer to the
                  edge, resulting in data savings, lower latencies, and new
                  revenue streams.
                </p>
              </div>

              <p>
                Inquire today with our dedicated enterprise sales team to learn
                how we can help your business take advantage of these
                connectivity opportunities.
              </p>

              <Button
                size="lg"
                className="bg-color--ocean-blue"
                href="mailto: enterprise@citysidenetworks.com"
              >
                Inquire Today
              </Button>
            </div>

            <div className={styles.imageWrap}>
              <Image
                sources={[
                  {
                    src: enterpriseImageM,
                    breakpoint: "default",
                  },
                  {
                    src: enterpriseImageD,
                    breakpoint: "960px",
                  },
                ]}
                alt="man in room with a lot of computer screens"
              />
            </div>
          </div>
        </div>
      </section>

      <Banner
        headline="Need a custom package? Reach out today!"
        text="We will work to build products and pricing customized for your business needs."
        btnText="sales@citysidefiber.com"
        btnLink="mailto: sales@citysidefiber.com"
      />
    </>
  );
};
